import CartAlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import CartAlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import React, { useContext } from 'react';
import { UserOrderContext } from 'context/context';
import { SET_COUPON_ERROR_MESSAGE } from 'organisms/CouponsLanding/Constants/CouponConstants';

export const removeCouponSuccessHandler = ({
  isAddedPromosCoupon,
  cartItem,
  setConfirmationModel,
  itemRemoveHandler,
  isRemoveItemLoading,
  setCouponModal,
  setRemoveItem,
  flag,
  quantityAction,
  updateItemQuantity,
  addtoCartClinckHandler,
  setAddToClickParms,
  addToClickParms,
  selectedStoreData,
  clickHandler,
  events,
  removeCouponHandler,
  couponCode,
  couponTitle,
  itemRemoveWrapper,
  userOrderStateDispatch
}) => {
  const { EDIT_ITEM, REMOVE_ITEM, QUANTITY_INCREASE_DECREASE, STORE_DISPOSITION_UPDATE, REMOVE_COUPON } =
    CART_PAGE_CONSTANTS;
  setCouponModal(false);
  if (flag === REMOVE_ITEM) {
    itemRemoveWrapper({
      isAddedPromosCoupon,
      item: cartItem,
      setConfirmationModel,
      itemRemoveHandler,
      isRemoveItemLoading,
      setRemoveItem,
    });
  }
  if (flag === QUANTITY_INCREASE_DECREASE) {
    userOrderStateDispatch({
      type: SET_COUPON_ERROR_MESSAGE,
      value: { couponErrorMessage: 'REMOVE' },
    });
    updateItemQuantity(cartItem, quantityAction, events);
  }
  if (flag === EDIT_ITEM) {
    const {
      event,
      data,
      miniPDPData,
      totalAmount,
      cartId,
      pdpDataForUpdateFoodLine,
      cartData: cartReducerData,
    } = addToClickParms;
    addtoCartClinckHandler(event, data, miniPDPData, cartId, totalAmount, pdpDataForUpdateFoodLine, cartReducerData);
    setAddToClickParms({});
    setCouponModal(false);
  }
  if (flag === STORE_DISPOSITION_UPDATE) {
    clickHandler(events, selectedStoreData);
  }
  if (flag === REMOVE_COUPON) {
    removeCouponHandler(couponCode, couponTitle);
  }
};

const RemoveGiftCardModal = props => {
  const {
    isAddedPromosCoupon = false,
    cartItem = {},
    setConfirmationModel = null,
    itemRemoveHandler = null,
    isRemoveItemLoading = false,
    setCouponModal = null,
    setRemoveItem = null,
    flag = '',
    quantityAction = '',
    updateItemQuantity = null,
    addtoCartClinckHandler = null,
    setAddToClickParms = null,
    addToClickParms = {},
    selectedStoreData = null,
    clickHandler = null,
    title = '',
    confirmButtonText = '',
    removeCouponHandler = null,
    couponCode = '',
    couponTitle = '',
    itemRemoveWrapper = null,
    giftCardOrVoucherErrMsg = '',
    giftCardErrFirstMsg = '',
  } = props;
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const { REMOVE_COUPON } = CART_PAGE_CONSTANTS;
  const { CONTINUE, CANCEL_BTN_TXT, REMOVE_GIFT_CARD_VOUCHER, CART_UPDATE_CLEAR_WICODE_FIRST_TEXT, CART_UPDATE_CLEAR_WICODE_SECOND_TEXT } = TRANSLATE_MAPPING_KEY;
  return (
    <CartAlertFormInsideModel
      handleClose={() => setCouponModal(false)}
      classNames='promos-rewards-warning-msg coupon-modal gift-card-voucher-remove-modal'
      CartAlertForm={
        <CartAlertForm
          title={flag === REMOVE_COUPON ? title : translateWithI18Next(REMOVE_GIFT_CARD_VOUCHER)}
          giftCardOrVoucherErrMsg={flag === REMOVE_COUPON ? giftCardOrVoucherErrMsg : translateWithI18Next(CART_UPDATE_CLEAR_WICODE_SECOND_TEXT)}
          giftCardErrFirstMsg={flag === REMOVE_COUPON ? giftCardErrFirstMsg : translateWithI18Next(CART_UPDATE_CLEAR_WICODE_FIRST_TEXT) }
          altText={''}
          confirmButtonText={flag === REMOVE_COUPON ? confirmButtonText : translateWithI18Next(CONTINUE)}
          confirmHandler={events =>
            removeCouponSuccessHandler({
              isAddedPromosCoupon,
              cartItem,
              setConfirmationModel,
              itemRemoveHandler,
              isRemoveItemLoading,
              itemRemoveWrapper,
              setCouponModal,
              setRemoveItem,
              flag,
              quantityAction,
              updateItemQuantity,
              addtoCartClinckHandler,
              setAddToClickParms,
              addToClickParms,
              selectedStoreData,
              clickHandler,
              events,
              removeCouponHandler,
              couponCode,
              couponTitle,
              userOrderStateDispatch
            })
          }
          cancelHandler={() => setCouponModal(false)}
          cancelButtonText={translateWithI18Next(CANCEL_BTN_TXT)}
        />
      }
    />
  );
};
export default RemoveGiftCardModal;
